import angular from 'angular';
import components from './components';
import scenes from './scenes';

export default angular.module(
  'scenes.loanAppSections.scenes.loanProductFinder',
  [components, scenes],
).name;
